import React, { Component } from 'react'

export default class error extends Component {
  render() {
    return (
      <div>
        Not found 404
      </div>
    )
  }
}
